module.exports = __webpack_public_path__ + "img/icon_time.d2c5d25d.svg";